import axios from 'axios';

// 전역 axios를 사용해 axios-interceptor.js의 토큰 리프레시 인터셉터가 적용되도록 한다.
const http = axios;

function showLoading() {
	const blinder = document.getElementById('blinder2');
	const loading = document.getElementById('loading');
	if (!blinder || !loading) return;
	blinder.style.display = 'block';
	loading.style.display = 'block';
}

function hideLoading() {
	const blinder = document.getElementById('blinder2');
	const loading = document.getElementById('loading');
	if (!blinder || !loading) return;
	blinder.style.display = 'none';
	loading.style.display = 'none';
}

const apiMixin = {
	methods: {
		async $_fetchRequest({
			method: method,
			url: url,
			data: data = {},
			params: params = {},
			isLoading: isLoading,
			headers: headers = {},
			timeout,
		}) {
			if (isLoading) {
				showLoading();
			}

			try {
				return await http({
					method: method,
					url: url,
					data: data,
					params: params,
					headers: headers,
					timeout: timeout,
				});
			} finally {
				if (isLoading) {
					hideLoading();
				}
			}
		},
	},
};

export default apiMixin;
